import React from 'react';
import { Divider, Flex, Typography } from '@banhala/ui-kit';
import { useGoodsPIPNInfo } from '../queries/useGoodsPIPNInfo';
import { isNil } from 'shared/src/utils';

function getDescription(value: unknown): string {
  if (typeof value === 'boolean') {
    return value ? '유' : '무';
  }
  return String(value ?? '');
}

export const PIPNInfo: React.FC = () => {
  const { data: goodsPIPNInfo } = useGoodsPIPNInfo();

  if (isNil(goodsPIPNInfo?.product_info_provision_notice)) return null;

  const { pipn_data } = goodsPIPNInfo.product_info_provision_notice;

  return (
    <Flex>
      <Divider size="small" />
      <Flex padding={{ horizontal: 16 }}>
        <Flex padding={{ vertical: 20 }}>
          <Typography type={'h5'} color={'content_primary'}>
            상품정보제공고시
          </Typography>
        </Flex>
        {Object.entries(pipn_data).map(([key, { title, value }]) => (
          <React.Fragment key={key}>
            <Flex.Row alignItems={'flex-start'} padding={{ vertical: 12 }}>
              <Flex width={120}>
                <Typography type={'body4'} color={'content_secondary'}>
                  {title}
                </Typography>
              </Flex>
              <Flex flex={3} margin={{ left: 4 }}>
                <Typography type={'body4'} color={'content_primary'}>
                  {getDescription(value)}
                </Typography>
              </Flex>
            </Flex.Row>
          </React.Fragment>
        ))}
      </Flex>
    </Flex>
  );
};
